export default "__VITE_ASSET__VVt1SZQG__"